import React from 'react';

import isPlainObject from 'lodash/isPlainObject';
import isString from 'lodash/isString';

import { ConfirmDialog, Grid, Stack, Typography } from '@gogame/components';
import { FormField, withForm } from '@gogame/form';

import IOTitle from 'scenes/IO/components/IOTitle';
import { loadUsersSuggestions } from 'scenes/IO/sources/businessEntities';

import { COMMENT } from './constants';
import { commentConfirmDialogSchema } from './schema';

export const CommentConfirmDialog = withForm({
  validationSchema: commentConfirmDialogSchema,
  enableReinitialize: true,
})(({
  title = 'Add comment',
  confirmActionLabel = 'Save',
  values,
  open,
  io,
  submitForm,
  onExited,
  onClose,
}) => {
  const handleSubmit = () => {
    submitForm(values);
  };

  return (
    <ConfirmDialog
      title={title}
      open={open}
      confirmActionLabel={confirmActionLabel}
      onExited={onExited}
      onClose={onClose}
      onSubmit={handleSubmit}
    >
      <Stack spacing={2}>
        <Typography>
          <IOTitle {...io} />{' '}
          {io.createdBy && isPlainObject(io.createdBy)
            ? 'by ' + io.createdBy.name
            : ''}
          {io.createdBy && isString(io.createdBy) ? 'by ' + io.createdBy : ''}
        </Typography>
        <Grid item xs={12}>
          <FormField.MentionsRichText
            label={'Comment *'}
            padding={0}
            name={COMMENT}
            autofocus={true}
            loadMentions={loadUsersSuggestions}
          />
        </Grid>
      </Stack>
    </ConfirmDialog>
  );
});
